/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel surface for the Video Debug Overlay.
 *
 * Also the View layer's only route to the overlay's model types — the
 * `model → viewModel → views` arrow means no component imports
 * `model/videoDebugOverlay` directly (see docs/MVVM-LAYERING-GATE.md).
 *
 * Thunks and selectors only: the slice's raw reducer actions and its
 * state/payload types are dispatched and used from inside the slice, so
 * they stay internal (CodingGuidelines §19.1).
 */

export { default as videoDebugOverlayReducer } from "./videoDebugOverlaySlice";
export {
  copyVideoDebugMetrics,
  initialiseVideoDebugOverlay,
  refreshVideoDebugMetrics,
  resetVideoDebugMetrics,
  selectIsVideoDebugOverlayPersisted,
  selectIsVideoDebugOverlayVisible,
  selectVideoDebugOverlayGroups,
  selectVideoDebugOverlayMode,
  setVideoDebugOverlayEnabled,
  toggleVideoDebugOverlay
} from "./videoDebugOverlaySlice";

// Re-exported for the View layer, which may not reach into src/model.
export {
  DebugOverlayMode,
  recordLastKeyCode
} from "../../model/videoDebugOverlay";
export type {
  TDebugMetricField,
  TDebugMetricGroup
} from "../../model/videoDebugOverlay";
